import React from 'react';

import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';

import  { history } from '../../store/configureStore';

import {
    getSortedShirtProfiles,
    getLoginState
} from '../../selectors/entities/users';
import {
    getSelectedAttrs,
    getSelectedButtons,
    getSelectedSize,
    recalculateShirtPrice,
    getSizesProfile,
    getSizeScenario,
    getSizesStandart,
    getSelectedFabricValues,
} from '../../selectors/entities/general';
import { getActivePreset } from '../../selectors/entities/ui';
import { getFromattedPreset } from '../../selectors/entities/filters';
import {
    getSizesProfileList,
    selectSizeProfile,
    changeSizeScenario
} from '../../actions/sizes';
import { addToCart, closeCartWidget } from '../../actions/general';
import { zoomButtonClicked, applyFilter, clearFilter } from '../../actions/ui';

import { Client } from '../../client';

import SelectSavedSizes from '../Sizes/SelectSavedSizes';
import { ParamsWrapper } from './FabricParams';
import { CommentWrapper } from './FabricComment';
import { RenderCartConstrButtons } from './Buttons';
import { ProductExtraInfo } from './ProductExtraInfo';
import { RenderDetails } from './ProductDetails';
import RenderRecommended from './Recommended';
import {CatalogFooter} from '../CatalogPage/Footer';
import SelectStandartSize from './SelectStandartSize';
import SizeModal from './SizeModal';
import CartErrorModal from '../CartErrorModal';
import ProductPreview from './ProductPreview';

import BackIcon from '../icons/BackIcon'
import GuaranteeIcon from '../icons/GuaranteeIcon';
import RubleIcon from '../icons/RubleIcon';
import RubleLightIcon from '../icons/RubleLightIcon';

const formName = 'ProductPage';

export const ErrorMessage = styled.h2`
    font-size: 16px;
    color: brown;
    margin: 16px;
    text-align: center;
`;

class ProductPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sizeModalOpened: false,
            errorMessage: null,
            errorModalOpened: false,
            imgSrc: '',
            imgSrcZoomed: '',
        }
    }

    componentDidMount = async () => {
        document.body.style.overflow = 'hidden';

        const { sizeActions } = this.props;
        await sizeActions.getSizesProfileList();
        this.setState({
            imgSrc: await this.getCatalogImageUrl('small', true),
            imgSrcZoomed: await this.getCatalogImageUrl('big', true),
        })
    }

    componentDidUpdate = async (prevProps) => {
        const { sizeActions, selectedFabric, activePreset } = this.props;

        if(selectedFabric.article !== prevProps.selectedFabric.article ||
            activePreset.id !== prevProps.activePreset.id) {
            await sizeActions.getSizesProfileList();
            this.setState({
                imgSrc: await this.getCatalogImageUrl('small', true),
                imgSrcZoomed: await this.getCatalogImageUrl('big', true),
            })
            document.querySelector('.b-rit-product-page-wrapper').scrollTo(0,0);
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    onSizeProfileSelect = (profile) => {
        this.props.sizeActions.selectSizeProfile(profile)
        this.props.sizeActions.changeSizeScenario('profile')
    }

    addToCart = async () => {
        const { data } = await this.props.actions.addToCart();
        setTimeout(() => { this.props.actions.closeCartWidget() }, 5000);

        if (data && data.error_id) {
            this.setState({
              errorMessage: data.error_message,
              errorModalOpened: true,
            });
        }
    }

    saveShirt = async () => {
        await this.props.actions.saveShirtToProfile()
    }

    getGuaranteeText = (isMobile) => (
        <div className='b-rit-product-page__guarantee-wrapper'>
            <GuaranteeIcon 
                size={isMobile ? 24 : 50} 
                color='currentColor' 
                className='b-rit-product-page__delivery_icon'
            />
            <p className='b-rit-product-page__guarantee-wrapper-title b-rit-product-page__subtitle'>Гарантия посадки</p>
            <p className='b-rit-product-page__guarantee-wrapper-text'>
                Мы гарантируем нашим клиентам превосходную посадку рубашки по фигуре. 
                Многолетний опыт и десятки тысяч довольных клиентов позволяют нам смело 
                заявлять об этом! Даже, если вам что-то не подойдет, не переживайте. 
                Мы в кратчайшие сроки доработаем рубашку за свой счет.
            </p>
        </div>
    )

    sizeModalToggle = () => {
        this.setState({
            sizeModalOpened: !this.state.sizeModalOpened,
        })
    }

    redirectToConstructor = () => { history.push(`/b_designer`) }

    onBack = () => { history.push(`/b_catalog`) }

    zoomToggle = () => {
        let toggled = !this.props.zoomMode
        store.dispatch(zoomButtonClicked(toggled))
    }

    changePreview = (x) => {
        const { selectedFabric: { article } } = this.props;

        const getPath = (size) => (
            x === 0 ? 
            this.getCatalogImageUrl(size, true) :
            this.getCatalogImageUrl(size, false, x)
        );

        this.setState({
            imgSrc: getPath('small'),
            imgSrcZoomed: getPath('big')
        })
    }

    getCatalogImageUrl = (size, isRender, number) => {
        const { selectedFabric, activePreset } = this.props;

        const article = selectedFabric.article.toLowerCase();
        const preset = getFromattedPreset(activePreset.id);
        return isRender ? 
            Client.getCatalogPresetsImageUrl(article, preset, size) :
            Client.getCatalogPreviewImageUrl(article, preset, size, number);
    }

    getSelectedSizesText = () => {
        const { sizeScenario, standartSizes } = this.props;
        if(sizeScenario === 'standart') {
            const {stdSize, height} = standartSizes;
            return `Стандартные размеры: Воротник - ${stdSize || '?'}, Рост - ${height || '?'}`;
        }
        return 'Выбрать профиль размеров';
    }

    render () {
        const {
            selectedFabric,
            shirtProfiles,
            islogined,
            selectedParts,
            selectedButton,
            sizes,
            zoomMode,
            activePreset,
            price,
            selectedProfile,
            isMobile,
            actions: { applyFilter, clearFilter }
        } = this.props;
        const { sizeModalOpened, imgSrc, imgSrcZoomed } = this.state;

        if(zoomMode) {
            return (
                <div className='b-rit-product-page-wrapper'>
                    <ProductPreview
                        imgSrc={imgSrcZoomed}
                        zoomToggle={this.zoomToggle}
                        changePreview={this.changePreview}
                        getCatalogImageUrl={this.getCatalogImageUrl}
                        selectedFabric={selectedFabric}
                        activePreset={activePreset}
                        zoomMode={zoomMode}/>
                </div>
            )
        }

        return (
            <div className='b-rit-product-page-wrapper'>
                <div className='b-rit-product-page'>
                    <div className='b-rit-product-page__preview-wrapper'>
                        <ProductPreview
                            imgSrc={imgSrc}
                            zoomToggle={this.zoomToggle}
                            changePreview={this.changePreview}
                            getCatalogImageUrl={this.getCatalogImageUrl}
                            selectedFabric={selectedFabric}
                            activePreset={activePreset}
                            zoomMode={zoomMode}
                            isMobile={isMobile}
                            />
                        <div className='b-rit-product-page__preview-params'>
                            {isMobile && <button className={'b-rit-product-page__preview-close'} onClick={this.onBack}>
                                <BackIcon size={15} color='currentColor' />
                            </button>}
                            {!isMobile &&
                                <p className='b-rit-product-page__style'>
                                    <span onClick={() => { clearFilter('styles'); this.onBack(); }}>
                                        Коллекция
                                    </span>
                                    &#160;/&#160;
                                    <span onClick={() => { applyFilter('styles', getFromattedPreset(activePreset.id), true); this.onBack(); }}>
                                        {activePreset.displayName}
                                    </span>
                                </p>}
                            <p className='b-rit-product-page__title'>{selectedFabric.displayName}</p>
                            <p className='b-rit-product-page__price'>
                                {price}&#160;
                                {isMobile ?
                                    <RubleLightIcon size={14} color='currentColor'/> :
                                    <RubleIcon size={18} color='currentColor'/>
                                }
                            </p>
                            <a 
                                className='b-rit-product-page__new-size-profile'
                                onClick={this.sizeModalToggle}
                            >
                                Создать профиль размеров
                            </a>
                            {islogined ?
                                <SelectSavedSizes
                                    shirtProfiles={shirtProfiles}
                                    onSizeSelect={this.onSizeProfileSelect}
                                    selectOnly={true}
                                    value={selectedProfile}
                                    defaultText={this.getSelectedSizesText()}
                                /> :
                                <SelectStandartSize/>
                            }
                            <RenderCartConstrButtons
                                sizes={sizes}
                                addToCart={this.addToCart}
                                redirectToConstructor={this.redirectToConstructor}/>
                            <ProductExtraInfo/>
                        </div>
                    </div>
                    <div className='b-rit-product-page__details-wrapper'>
                        <p className='b-rit-product-page__subtitle b-rit-product-page__details-wrapper-title'>Детали</p>
                        <RenderDetails details={selectedParts} fabric={selectedFabric} button={selectedButton} isMobile={isMobile}/>
                    </div>
                    <div className='b-rit-product-page__to-constructor'>
                        Изменить детали, добавить монограмму, карман и другие элементы можно в&nbsp;
                        <u onClick={this.redirectToConstructor}>конструкторе</u>
                    </div>
                    <div className='b-rit-product-page__description-wrapper'>
                        <p className='b-rit-product-page__description-wrapper-title b-rit-product-page__subtitle'>Описание ткани</p>
                        <CommentWrapper {...selectedFabric} />
                        <ParamsWrapper {...selectedFabric} />
                    </div>
                    {this.getGuaranteeText(isMobile)}
                    <RenderRecommended isMobile={isMobile} />
                    {sizeModalOpened && 
                        <SizeModal 
                            onClose={() => {}} 
                            toggle={this.sizeModalToggle} 
                            closeOnEsc={true}/>
                    }
                    <CartErrorModal
                        title={'Не удалось добавить рубашку в корзину'}
                        isOpened={this.state.errorModalOpened}
                        onClose={() => this.setState({ errorModalOpened: false, errorMessage: null })}
                        closeOnEsc={true}
                        errorMessage={this.state.errorMessage}
                    />
                </div>
            </div>
        )
    }
}

ProductPage.propTypes = {
    selectedFabric: PropTypes.object.isRequired,
    islogined: PropTypes.bool.isRequired,
    shirtProfiles: PropTypes.array.isRequired,
    selectedParts: PropTypes.object.isRequired,
    selectedButton: PropTypes.object.isRequired,
    sizes: PropTypes.object,
    zoomMode: PropTypes.bool.isRequired,
    activePreset: PropTypes.object.isRequired,
    price: PropTypes.number.isRequired,
    selectedProfile: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    standartSizes: PropTypes.object,
    sizeScenario: PropTypes.string,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        selectedFabric: getSelectedFabricValues(state),
        islogined: getLoginState(state),
        shirtProfiles: getSortedShirtProfiles(state),
        selectedParts: getSelectedAttrs(state),
        selectedButton: getSelectedButtons(state),
        sizes: getSelectedSize(state),
        zoomMode: state.ui.zoomMode,
        activePreset: getActivePreset(state),
        price: recalculateShirtPrice(state),
        selectedProfile: getSizesProfile(state),
        isMobile: state.ui.isMobile,
        standartSizes: getSizesStandart(state),
        sizeScenario: getSizeScenario(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            addToCart,
            closeCartWidget,
            applyFilter,
            clearFilter,
        }, dispatch),
        sizeActions: bindActionCreators({
            getSizesProfileList,
            selectSizeProfile,
            changeSizeScenario
        }, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)((
    reduxForm({
      form: formName,
      destroyOnUnmount: false,
      forceUnregisterOnUnmount: true,
      enableReinitialize: true,
    })(ProductPage))
);
